import * as React from "react";
import sha1 from "crypto-js/sha1";
import { useGlobalData } from "../../contexts";
import { useLocation } from "react-router";
import queryString from "query-string";

export type PaimentData = {
  amount: number;
  cn: string;
  structuredCommunicationFormated: string;
  structuredCommunicationRaw: string;
};
export interface IIngenicoPaimentProps {
  triggerPaiment: boolean;

  data: PaimentData;
  returnParams: (data: any) => void;
}

export const IngenicoPaiment: React.FunctionComponent<IIngenicoPaimentProps> = ({
  data,
  triggerPaiment,
  returnParams,
}) => {
  const { currentLanguage, ingenicoSettings } = useGlobalData();
  const computedLanguage = React.useMemo(() => {
    if (currentLanguage.languageCode.toLowerCase() === "fr") {
      return "fr_FR";
    }
    return "fr_FR";
  }, [currentLanguage]);

  const { psId, ingenicoUrl, sha1Key } = React.useMemo(
    () => ({
      psId: ingenicoSettings?.psId,
      ingenicoUrl: ingenicoSettings?.paymentUrl,
      sha1Key: ingenicoSettings?.sha1Key,
    }),
    [ingenicoSettings?.paymentUrl, ingenicoSettings?.psId, ingenicoSettings?.sha1Key]
  );
  const location = useLocation();
  // return params from ingenico.
  //TODO-CRR : ? not used ?
  //Not used here but still usefull, if not here payemnt does not work

  // return params from ingenico.
  React.useEffect(() => {
    var queryparams = queryString.parse(location.search);
    if (Object.keys(queryparams).length > 0) {
      returnParams(queryparams);
    }
  }, [location.search, returnParams]);

  const fullUrl = React.useMemo(() => window.location.href, []);
  const shaContent = React.useMemo(() => {
    if (data) {
      const stringToHash =
        "ACCEPTURL=" +
        fullUrl +
        sha1Key +
        "AMOUNT=" +
        data.amount +
        sha1Key +
        "CURRENCY=EUR" +
        sha1Key +
        "DECLINEURL=" +
        fullUrl +
        sha1Key +
        "LANGUAGE=" +
        computedLanguage +
        sha1Key +
        "ORDERID=" +
        data.structuredCommunicationFormated +
        sha1Key +
        "PSPID=" +
        psId +
        sha1Key;
      return sha1(stringToHash).toString();
    }
    return "";
  }, [computedLanguage, data, fullUrl, psId, sha1Key]);

  const formRef = React.useRef<HTMLFormElement>(null);

  React.useLayoutEffect(() => {
    if (formRef.current && formRef.current.submit && triggerPaiment) {
      formRef.current.submit();
    }
  }, [triggerPaiment]);

  if (!data) {
    return null;
  }

  return (
    <form method="post" action={ingenicoUrl} id="form1" name="form1" ref={formRef}>
      <input type="hidden" name="ACCEPTURL" value={fullUrl} />
      <input type="hidden" name="AMOUNT" value={data.amount} />
      <input type="hidden" name="CURRENCY" value="EUR" />
      <input type="hidden" name="DECLINEURL" value={fullUrl} />
      <input type="hidden" name="LANGUAGE" value={computedLanguage} />
      <input type="hidden" name="ORDERID" value={data.structuredCommunicationFormated} />
      <input type="hidden" name="PSPID" value={psId} />
      <input type="hidden" name="SHASIGN" value={shaContent} />
    </form>
  );
};
